export default "__VITE_ASSET__Jm_U89vP__"